import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Col, Row, Button } from 'react-bootstrap';
import './Login.css';

export const Login = () => {
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [showError, setShowError] = useState(false);
  //IDP endpoint
  const api = process.env.REACT_APP_IDP_PROVIDER;
  const accountEndpoint = `${api}/account/login/`;

  const submitLogin = async (formData) => {
    setShowError(false);
    const loginData = {
      email: formData.get('email'),
      password: formData.get('password'),
    };
    try {
      const response = await fetch(accountEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(loginData),
      });
      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('token', data);
        navigate('/activities');
      } else if (response.status === 401) {
        navigate('/');
      } else {
        setShowError(true);
      }
    } catch (error) {
      setShowError(true);
    }
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    var loginData = new FormData(form);

    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity()) {
      await submitLogin(loginData);
    }
    setValidated(true);
  };

  const forgotPassword = () => {
    navigate('/reset-password');
  };

  return (
    <>
      <div className='container'>
        <Row>
          <Col className='login-container' md="6">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Row className='mb-3'>
                <Form.Group as={Col} md="12" controlId="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control name='email' type="text" placeholder="Email" required />
                  <Form.Control.Feedback type='invalid'>User email is required.</Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className='mb-3'>
                <Form.Group as={Col} md="12" controlId="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control name='password' type="password" placeholder="Password" required />
                  <Form.Control.Feedback type='invalid'>Password is required.</Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className='mb-3'>
                <Col md="6">
                  <Button className="forgot-password remove-filter-link" onClick={forgotPassword}>Forgot password?</Button>
                </Col>
                <Col md="6">
                  <Button variant="login" type="submit">
                    Login
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        {showError &&
          <Row>
            <Col md="12">
              <div className="login-error">
                <span>Login Failed: Invalid Login Credentials.</span>
              </div>
            </Col>
          </Row>}
      </div>
    </>
  )

};